import { render, staticRenderFns } from "./district-management.vue?vue&type=template&id=7b8f5797&scoped=true"
import script from "./district-management.vue?vue&type=script&lang=js"
export * from "./district-management.vue?vue&type=script&lang=js"
import style0 from "./district-management.vue?vue&type=style&index=0&id=7b8f5797&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f5797",
  null
  
)

export default component.exports